import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { MenuService } from './menu.service';
import { AuthService } from '../../services/auth.service';
import { MatIconModule } from '@angular/material/icon';
import { Menu } from '../../model/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltip } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { LinkLoadingDirective } from '../../directives/link-loading.directive';
import { SidebarStateService } from './sidebar-state.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Component({
  animations: [
    trigger('myInsertRemoveTrigger', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms', style({ opacity: 0 }))
      ])
    ])
  ],
  selector: 'app-sidebar',
  imports: [CommonModule, MatIconModule, MatExpansionModule, MatTooltip, RouterModule, LinkLoadingDirective],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent implements OnInit, OnDestroy {

  private sub = new Subscription();
  @Input() sidebarCollapsed: boolean = false;
  @Output() toggleSidebar = new EventEmitter<void>();

  dados: any;
  isVisible = false;
  perfil_usuario = 'Gestor';

  
  constructor(
    private readonly _menuService: MenuService,
    private readonly _servicoAuth: AuthService,
    private readonly _oidc: OidcSecurityService,
    public router: Router,
    public state: SidebarStateService
  ) { 

  }

  ngOnInit() {

    // Carrega o menu assim que houver sessão, em qualquer rota — antes isto
    // dependia da HomeComponent disparar carregarMenu$
    this.sub.add(
      this._oidc.isAuthenticated$
        .pipe(filter(({ isAuthenticated }) => isAuthenticated), take(1))
        .subscribe(() => this.ObterDadosMenu())
    );

    // Recarga explícita (ex.: troca de cliente)
    this.sub.add(
      this.state.carregarMenu$.subscribe(() => this.ObterDadosMenu())
    );

  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  async ObterDadosMenu(){
    try {
      console.log('🔄 Sidebar: Iniciando carregamento do menu...');
      this.dados = await this._menuService.getDados();
    } catch (error) {
      console.error('❌ Sidebar: Erro ao obter dados do menu:', error);
      this.dados = [];
    }
  }

  toggleSubItem(item: any) {
    if (item.subitem?.length) {
      item.expanded = !item.expanded;
    }
  }

  carregarMenu(): Menu[] {
    return this.dados;
  }

  isActive(url: string): boolean {
    return this.router.url === this.normalizeUrl(url);
  }

  isSubActive(url: string): boolean {
    return this.router.url.startsWith(this.normalizeUrl(url));
  }

  private normalizeUrl(url: string): string {
    return url.startsWith('/') ? url : '/' + url;
  }
}